<!--仿tab页头-->
<template>
  <div
    class="page-header "
    :class="hasBackground?'has-background':''"
  >
    <p class="page-title">
      <slot></slot>
    </p>
    <span
      class="line"
      v-if="hasLine"
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    hasLine: {
      type: Boolean,
      default: false,
    },
    hasBackground: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  display: inline-block;
  box-sizing: border-box;
  cursor: pointer;
  &.has-background {
    background: #f2f5f7;
    border-radius: 4px;
    padding: 9px 16px;
    margin: 24px 0 20px 0;
  }
  margin-top: 2px;
  // flex:1;
  width: 0;
  flex-grow: 1;
  flex-shrink: 0;
  // margin-right: 20px;
  .page-title {
    width: 100%;
    line-height: 25px;
    font-size: 16px;
    color: #1f2123;
    font-weight: 500;
    overflow: hidden;
  }
  .line {
    display: block;
    width: 15px !important;
    height: 4px;
    border-radius: 2px;
    background-color: $primaryColor;
    margin-top: 6px;
    box-shadow: 0px 3px 8px 0px $tab_line_shadow;
  }
}
</style>
